export default {
    title: 'DISCOVERY PACKAGES',
    section1: {
        heading: 'ACCESS TO MIXED FUNDS',
        description: 'Members have access to mixed boxes on a monthly basis selected by Boires. The possibility of having bottles in private import, without having to buy them at the full checkout!'
    },
    section2: {
        heading: 'PREFERENTIAL PRICES',
        description: 'The discovery packages allow you to have access to private import products at preferential prices.'
    },
    section3: {
        heading: 'HOW IT WORKS?',
        description: 'Do you want to discover new wines, have access to a changing mixed case or you just do not know what to choose from our list of artisan wines? The Discovery Package for you!<br/> Monthly or annual subscription. You have until the first Monday of each month to confirm your order and it will be delivered on the 2nd Tuesday of the month.'
    },
    box1: {
        title: 'Package 1',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '290',
        subscribe: 'Subscribe',
        time: '/month'
    },
    box2: {
        title: 'Package 2',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '380',
        subscribe: 'Subscribe',
        time: '/month'
    },
    box3: {
        title: 'Package 3',
        description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.',
        plan: '500',
        subscribe: 'Subscribe',
        time: '/year'
    },
    package: '3 DISCOVERY PACKAGES',
    commitment: 'Without commitment, stop your subscription at any time.'
};
